export default "__VITE_ASSET__422dadcd__"